<template>
    <b-overlay :show="is_load" rounded="sm">
        <div class="products" v-if="products.length > 0">
            <div class="prod_info" v-for="product in products">

                <div class="user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2  px-2 p-1">
                    <div class="d-flex flex-row pt-2 pb-1">
                        <span class="status">
                            <img class="profile-image rounded-circle d-inline-block" :src="product.image">
                        </span>

                        <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(product)" >
                              <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                                  <i class="fal fa-times"></i>
                              </span>
                        </span>

                        <span class="position-absolute override_settings" v-if="product.hasOwnProperty('has_override')">
                             <div class="custom-control custom-checkbox">
                                    <input
                                        :name="'cid[]'"
                                        v-model="product.has_override"
                                        type="checkbox"
                                        @change="change_atr(product)"
                                        class="custom-control-input"
                                        :id="product.id + '_cust_id'" />
                                    <label class="custom-control-label cursor-pointer bolder" :for="product.id + '_cust_id'">
                                        {{__t('HAS_OVERRIDE')}}
                                    </label>
                                </div>
                        </span>


                        <div class="user_attrib ml-3">
                            <div class="name d-block fw-700 text-dark">
                                {{product.title}}
                            </div>
                            <div class="company small text-dark">
                                {{product.price}}
                            </div>
                        </div>
                    </div>

                    <div class="override_settings mt-2 mb-2" v-if="product.has_override">
                        <info_field
                            f_uniq="cid_min_over"
                            f_type="min_qual"
                            :is_disabled="false"
                            @update_categ="(f_type, cur_val) => change_attr_override(f_type, cur_val,product)"
                            :f_title="__t('MIN_QUAL')"
                            :f_val="product.override.min">
                        </info_field>

                        <info_field
                            f_uniq="cid_max_over"
                            f_type="max_qual"
                            :is_disabled="false"
                            @update_categ="(f_type, cur_val) => change_attr_override(f_type, cur_val,product)"
                            :f_title="__t('MAX_QUAL')"
                            :f_val="product.override.max">
                        </info_field>

                    </div>
                </div>

            </div>
        </div>
    </b-overlay>
</template>

<script>
import Product_inside_list from "../../../products/inside_list/product_inside_list.vue";
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "group_attached_products",
    components: {Info_field, Product_inside_list},
    props : {
        group : {
            type : Object
        }
    },
    data() {
        return {
            is_load: true,
            attached_products : [],
        }
    },

    mounted() {
        this.load_items();
    },

    methods : {

        change_atr(product) {

            this.$emit('on_group_change',{
                "type"      : 'override',
                "prod"      : {
                    "has_override"  : product.has_override,
                    "min"           : product.override.min,
                    "max"           : product.override.max,
                    "prod_id"       : product.prod_id,
                },
            })
        },

        change_attr_override(type,val,product) {

            if (!product.override) {
                product.override = {};
            }

            if (type === 'min_qual') {
                product.override.min = val;
            } else if (type === 'max_qual') {
                product.override.max = val;
            }

            this.change_atr(product);
        },

        async  remove_item(record) {
            this.is_load = true;
            await api.delete('/internal/v1/catalog/modifiers/'+ parseInt(record.modif_id) + "/product/" + record.prod_id)
                .then(({data}) => {
                    if (data.status === "operation_success") {
                        this.load_items();
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                });
        },

        async load_items() {
            this.is_load = true;
            this.attached_products = [];

            await api.get('/internal/v1/catalog/modifiers/groups/'+ parseInt(this.group.id) + "/products").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.attached_products = data.data;

                    if(this.products.length > 0) {
                        this.products.map(item => {
                            if(item.has_override) {
                                this.change_atr(item);
                            }
                        });
                    }

                }
            }).catch(({response}) => {
                this.is_load = false;
            });
        },
    },

    computed : {

        products () {
            if(this.attached_products != null && this.attached_products.length > 0) {
                return this.attached_products.map(item => {
                    item.image = '/product/' + item.prod_id +'/image/' + item.client_id +'/100/100/' +item.client_id  +'.webp'
                    try {
                        let prod = item.product;
                        if(prod != null) {
                            item.title = prod.title;
                            item.price =  prod.price;
                        }
                    }
                    catch (e) {

                    }
                    return item;
                });
            }

            return [];
        }
    }
}
</script>

<style scoped>

.override_settings {
    right: 50px;
    top: 16px;
}

.remove {
    right: 10px;
}
</style>
